import { createEnv } from '@t3-oss/env-nextjs'
import { envBooleanFlag, envBrandId, envOptionalString, envString, envUrl } from './schema'

export const env = createEnv({
  client: {
    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: envString,
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: envString,

    NEXT_PUBLIC_POSTHOG_KEY: envString,
    NEXT_PUBLIC_POSTHOG_PROJECT_ID: envString,
    NEXT_PUBLIC_POSTHOG_HOST: envUrl,

    NEXT_PUBLIC_META_PIXEL_ID: envString,
    NEXT_PUBLIC_META_TEST_EVENT_CODE: envOptionalString,
    NEXT_PUBLIC_X_PIXEL_ID_CHRISTSPIRACY: envString,
    NEXT_PUBLIC_X_PIXEL_ID_WWJD: envString,
    NEXT_PUBLIC_X_PIXEL_PURCHASE_EVENT_ID_CHRISTSPIRACY: envString,
    NEXT_PUBLIC_X_PIXEL_PURCHASE_EVENT_ID_WWJD: envString,

    NEXT_PUBLIC_PAYPAL_CLIENT_ID: envString,

    NEXT_PUBLIC_GTM_ID: envString,
    NEXT_PUBLIC_DEBUG: envBooleanFlag,
    NEXT_PUBLIC_DEV_BRAND_ID: envBrandId,
  },
  runtimeEnv: {
    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_PROJECT_ID: process.env.NEXT_PUBLIC_POSTHOG_PROJECT_ID,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    NEXT_PUBLIC_META_PIXEL_ID: process.env.NEXT_PUBLIC_META_PIXEL_ID,
    NEXT_PUBLIC_META_TEST_EVENT_CODE: process.env.NEXT_PUBLIC_META_TEST_EVENT_CODE,
    NEXT_PUBLIC_X_PIXEL_ID_CHRISTSPIRACY: process.env.NEXT_PUBLIC_X_PIXEL_ID_CHRISTSPIRACY,
    NEXT_PUBLIC_X_PIXEL_ID_WWJD: process.env.NEXT_PUBLIC_X_PIXEL_ID_WWJD,
    NEXT_PUBLIC_X_PIXEL_PURCHASE_EVENT_ID_CHRISTSPIRACY:
      process.env.NEXT_PUBLIC_X_PIXEL_PURCHASE_EVENT_ID_CHRISTSPIRACY,
    NEXT_PUBLIC_X_PIXEL_PURCHASE_EVENT_ID_WWJD:
      process.env.NEXT_PUBLIC_X_PIXEL_PURCHASE_EVENT_ID_WWJD,
    NEXT_PUBLIC_PAYPAL_CLIENT_ID: process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID,
    NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
    NEXT_PUBLIC_DEBUG: process.env.NEXT_PUBLIC_DEBUG,
    NEXT_PUBLIC_DEV_BRAND_ID: process.env.NEXT_PUBLIC_DEV_BRAND_ID,
  },
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  emptyStringAsUndefined: true,
})
